import { z } from 'zod'
import { TrueFalse } from '~/enums/true-false'

/** 產品子網頁 - 多筆資料 Schema */
export const productPagesListDataSchema = z.object({
  /** ID */
  ppID: z.number(),
  /** 產品主類目中文名稱 */
  pmNameZh: z.string(),
  /** 產品子類目中文名稱 */
  psNameZh: z.string(),
  /** 產品子網頁分類中文名稱 */
  psiNameZh: z.string(),
  /** 產品子網頁分類英文名稱 */
  psiNameEn: z.string(),
  /** 作者 */
  author: z.string(),
  /** 發布時間 */
  releaseDate: z.string(),
  /** 更新時間 */
  modifyDate: z.string(),
  /** 是否置頂 */
  isTop: z.nativeEnum(TrueFalse),
  /** 是否上架 */
  isEnable: z.nativeEnum(TrueFalse),
  /** 標題-中文版 */
  titleZh: z.string().optional(),
  /** 標題-英文版 */
  titleEn: z.string().nullable().optional(),
  /** 內容-中文版 */
  contentZh: z.string().optional(),
  /** 內容-英文版 */
  contentEn: z.string().optional()
})

/**
 * 產品子網頁 - 多筆資料
 */
export interface ProductPagesListData
  extends z.infer<typeof productPagesListDataSchema> {}
